import { config } from '../config';
import { ApiError } from './client';

export async function signupShopAdmin(payload) {
  const response = await fetch(`${config.platformApiUrl}/api/v1/signup`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  const data = await response.json().catch(() => null);

  if (!response.ok) {
    console.error('Signup API error', { status: response.status, detail: data?.detail, body: data });
    const detail = data?.detail;
    const message =
      typeof detail === 'string'
        ? detail
        : Array.isArray(detail)
          ? detail.map((item) => item.msg || JSON.stringify(item)).join(', ')
          : `Signup failed (${response.status})`;
    throw new ApiError(message, response.status, detail);
  }

  return data;
}
